(() => {
  const EVENTS = ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'];
  const ICON = '<svg width="56" height="56" viewBox="0 0 56 56" aria-hidden="true"><path transform="translate(14, 14)" fill-rule="evenodd" clip-rule="evenodd" fill="rgba(0,0,0,0.7)" d="M18.9481 2.06543C19.8872 2.06542 20.6625 2.06512 21.2939 2.1167C21.9497 2.17028 22.5529 2.28506 23.1191 2.57357C23.9971 3.02093 24.7111 3.73502 25.1585 4.61296C25.447 5.17914 25.5618 5.78243 25.6154 6.43815C25.667 7.06954 25.6667 7.8449 25.6666 8.78402V15.1802C25.6667 16.1193 25.667 16.8947 25.6154 17.526C25.5618 18.1818 25.447 18.7851 25.1585 19.3512C24.7111 20.2292 23.9971 20.9433 23.1191 21.3906C22.5529 21.6791 21.9497 21.7939 21.2939 21.8475C20.6625 21.8991 19.8872 21.8988 18.9481 21.8988H15.9642C15.1896 21.8988 14.964 21.9045 14.7588 21.9466C14.5529 21.9889 14.3535 22.0584 14.1663 22.154C13.9797 22.2493 13.7995 22.3866 13.1945 22.8706L10.3792 25.123C10.1651 25.2944 9.94672 25.469 9.75485 25.5959C9.57118 25.7173 9.2152 25.9348 8.75225 25.9354C8.21939 25.936 7.71526 25.6933 7.38278 25.2769C7.09406 24.9152 7.04043 24.5016 7.02048 24.2822C6.99966 24.053 6.99992 23.7728 6.99997 23.4984V21.8896C6.54292 21.8746 6.15096 21.8354 5.79229 21.7393C4.18193 21.3077 2.92431 20.0502 2.49281 18.4398C2.33288 17.8429 2.3328 17.1539 2.3333 16.2261V8.78402C2.33329 7.84488 2.33299 7.06955 2.38457 6.43815C2.43816 5.78242 2.55409 5.17915 2.84258 4.61296C3.29001 3.73514 4.00408 3.02087 4.88197 2.57357C5.44795 2.28532 6.05057 2.17027 6.70603 2.1167C7.3374 2.06511 8.11279 2.06542 9.05189 2.06543H18.9481ZM8.16664 12.5654C7.52233 12.5655 6.99997 13.0878 6.99997 13.7321C6.99997 14.3764 7.52233 14.8987 8.16664 14.8988H17.5C18.1443 14.8988 18.6666 14.3764 18.6666 13.7321C18.6666 13.0878 18.1443 12.5654 17.5 12.5654H8.16664ZM8.16664 8.4821C7.52233 8.48212 6.99997 9.00445 6.99997 9.64876C6.99997 10.2931 7.52233 10.8154 8.16664 10.8154H14C14.6443 10.8154 15.1666 10.2931 15.1666 9.64876C15.1666 9.00443 14.6443 8.4821 14 8.4821H8.16664Z"/></svg>';

  const inOfficeHours = () => {
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Australia/Melbourne' }));
    const day = now.getDay();
    const hour = now.getHours();
    return day >= 1 && day <= 5 && hour >= 9 && hour < 17;
  };

  const SETTINGS = 'https://chat.frontapp.com/cec40b998f9bdda7438f2d158205e5ab/settings';

  const frontSettings = () => {
    try {
      const saved = sessionStorage.getItem('au-front-settings');
      if (saved) return Promise.resolve(JSON.parse(saved));
    } catch (_) {}
    return fetch(SETTINGS)
      .then((res) => (res.ok ? res.json() : null))
      .then((all) => {
        if (!all) return null;
        const keep = { isWidgetVisible: all.isWidgetVisible, onlineHours: all.onlineHours, widgetPlacement: all.widgetPlacement, color: all.color };
        try {
          sessionStorage.setItem('au-front-settings', JSON.stringify(keep));
        } catch (_) {}
        return keep;
      })
      .catch(() => null);
  };

  const online = (hours) => {
    if (!hours || !hours.shouldHideWhenOutsideOnlineHours) return true;
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: hours.timezone, weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    const part = (type) => (parts.find((p) => p.type === type) || {}).value;
    const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(part('weekday'));
    const time = `${part('hour')}:${part('minute')}`;
    return (hours.rules || []).some((rule) => (rule.days.includes(day) || (day === 0 && rule.days.includes(7))) && time >= rule.timerange.start_time && time < rule.timerange.end_time);
  };

  const hasConversation = () => {
    try {
      return localStorage.getItem('frontChat:store') !== null;
    } catch (_) {
      return false;
    }
  };

  const loadChat = (open, done) => {
    const script = document.createElement('script');
    script.src = 'https://chat-assets.frontapp.com/v1/chat.bundle.js';
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.referrerPolicy = 'no-referrer-when-downgrade';
    script.onerror = () => done && done(false);
    script.onload = () => {
      if (typeof window.FrontChat !== 'function') return done && done(false);
      window.FrontChat('init', {
        chatId: 'cec40b998f9bdda7438f2d158205e5ab',
        useDefaultLauncher: true,
        shouldShowWindowOnLaunch: open,
        shouldExpandOnShowWindow: false,
        shouldHideCloseButton: false,
        shouldHideExpandButton: false,
        welcomeMessageAppearance: window.matchMedia('(max-width: 1023px)').matches ? 'hidden' : undefined,
      });
      if (!done) return;
      const ready = () => document.getElementById('front-chat-iframe');
      if (ready()) return done(true);
      const watch = new MutationObserver(() => {
        if (!ready()) return;
        watch.disconnect();
        done(true);
      });
      watch.observe(document.body, { childList: true });
    };
    document.head.appendChild(script);
  };

  const launcher = (settings) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'au-chat-launcher';
    const place = settings && settings.widgetPlacement;
    if (place) {
      button.style.setProperty('--au-chat-side', `${place.widgetSideSpacing}px`);
      button.style.setProperty('--au-chat-bottom', `${place.widgetBottomSpacing}px`);
      if (place.widgetPlacementLocation === 'bottom_left') button.dataset.side = 'left';
    }
    if (settings && settings.color) button.style.setProperty('--au-chat-color', settings.color);
    button.setAttribute('aria-label', 'Chat with us');
    button.innerHTML = ICON;
    button.addEventListener('click', () => {
      if (button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      loadChat(true, (ok) => (ok ? button.remove() : button.removeAttribute('aria-busy')));
    });
    document.body.appendChild(button);
  };

  // Front's own settings (1.5 KB, once per session) give the hours, visibility, colour and position; the office hours above are the fallback.
  const start = (settings) => {
    if (settings ? !settings.isWidgetVisible || !online(settings.onlineHours) : !inOfficeHours()) return;
    if (window.matchMedia('(max-width: 1023px)').matches && !hasConversation()) return launcher(settings);

    let started = false;
    const begin = () => {
      if (started) return;
      started = true;
      EVENTS.forEach((type) => window.removeEventListener(type, begin));
      if ('requestIdleCallback' in window) requestIdleCallback(() => loadChat(false), { timeout: 5000 });
      else loadChat(false);
    };
    EVENTS.forEach((type) => window.addEventListener(type, begin, { passive: true }));
    setTimeout(begin, 30000);
  };

  window.addEventListener('load', () => {
    if (navigator.connection?.saveData || (navigator.deviceMemory || 4) < 2) return;
    frontSettings().then(start);
  });
})();
